/**
 * Limiti di caricamento: per singolo file e per invio (tutti i file mandati
 * insieme). Li decide il backend in base al piano e li applica comunque lui;
 * qui servono a dirlo prima di caricare per niente.
 */

const MB = 1024 * 1024;

/** Finche' il backend non risponde: il limite di sempre. ``diretto``: i
 * file si caricano su S3 (caricamentoDiretto.js). */
export const LIMITI_PREDEFINITI = { file_mb: 10, invio_mb: 10, diretto: false };

/** Accetta solo numeri positivi dal server, altrimenti i predefiniti. */
export function limitiValidi(dati) {
  const ok = (n) => Number.isFinite(n) && n > 0;
  return ok(dati?.file_mb) && ok(dati?.invio_mb)
    ? { file_mb: dati.file_mb, invio_mb: dati.invio_mb, diretto: dati.diretto === true }
    : LIMITI_PREDEFINITI;
}

/** "10 MB per invio", oppure "20 MB per file, 100 MB per invio". */
export function testoLimiti({ file_mb, invio_mb }) {
  return file_mb >= invio_mb ? `${invio_mb} MB per invio` : `${file_mb} MB per file, ${invio_mb} MB per invio`;
}

function mb(byte) {
  return (byte / MB).toLocaleString("it-IT", { maximumFractionDigits: 1 });
}

/**
 * I file oltre il limite per file non entrano nell'elenco: non si potrebbero
 * mai inviare, e vederli caricati farebbe pensare il contrario.
 */
export function separaTroppoGrandi(files, { file_mb }) {
  const ammessi = [];
  const scartati = [];
  for (const f of Array.from(files || [])) (f.size > file_mb * MB ? scartati : ammessi).push(f);
  return { ammessi, scartati };
}

/** Perche' quei file sono rimasti fuori; null se non ce ne sono. */
export function messaggioScartati(scartati, { file_mb }) {
  const lista = Array.from(scartati || []);
  if (!lista.length) return null;
  if (lista.length === 1) {
    return `Il file "${lista[0].name}" non è stato aggiunto: pesa ${mb(lista[0].size)} MB e il limite è ${file_mb} MB per file.`;
  }
  const elenco = lista.map((f) => `"${f.name}" (${mb(f.size)} MB)`).join(", ");
  return `${lista.length} file non sono stati aggiunti perché superano il limite di ${file_mb} MB per file: ${elenco}.`;
}

/**
 * Il primo limite superato, come frase per l'utente; null se va tutto bene.
 * Un file troppo grande qui c'e' solo se i limiti sono scesi dopo che era
 * entrato (per esempio uscendo dall'account).
 */
export function controllaLimiti(files, { file_mb, invio_mb }) {
  const lista = Array.from(files || []);
  const grande = lista.find((f) => f.size > file_mb * MB);
  if (grande) {
    return `"${grande.name}" pesa ${mb(grande.size)} MB: il limite è ${file_mb} MB per file. Riducilo o toglilo dall'elenco.`;
  }
  const totale = lista.reduce((s, f) => s + (f.size || 0), 0);
  if (totale > invio_mb * MB) {
    return `I file caricati pesano ${mb(totale)} MB in tutto: il limite è ${invio_mb} MB per invio. Togli qualche file e anonimizza gli altri in un secondo momento.`;
  }
  return null;
}
